export default "__VITE_ASSET__95d9896e__"